// extracted by mini-css-extract-plugin
export default {"container":"InputBox_container__2j+6X","headerBox":"InputBox_headerBox__UH4CV","header":"InputBox_header__mgEtH","inputBox":"InputBox_inputBox__dfyoe"};